import React, { useEffect, useRef, useState } from 'react';
import { FaBriefcase, FaMobileAlt, FaSearch, FaAward, FaComments, FaBars, FaTimes, FaCheckCircle, FaUserTie, FaEnvelope, FaUser, FaHardHat } from 'react-icons/fa';
import { BsShieldCheck, BsGraphUp, BsClipboardCheck, BsBinoculars } from 'react-icons/bs';
import Slider from 'react-slick';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { toast } from 'react-toastify';


import styles from './LandingPage.module.css';
import FeaturedBusinessBanner from '../../components/FeaturedBusinessBanner/FeaturedBusinessBanner';
import { Link, useNavigate } from 'react-router-dom';

import SearchFormComponent from "../../pages/Dashboards/SearchFormComponent";
import "../../pages/Dashboards/SearchForm.module.css";
/*import searchstyles from './SearchForm.module.css'; */

import imageBizConnect from "../../assets/images/bussiness-home-vector.png";
import imageJobs from "../../assets/images/image_circle_post.png";
import imageConnect from "../../assets/images/image_circle_search.png";

import imageLogo from "../../assets/images/LogoBuildStart03.png";

import SocialProofEngine from '../../components/SocialProof/SocialProofEngine'; // Adjust the 

import AiSearchAssistant from "../../components/AiSearchAssistant/AiSearchAssistant";

// --- Sub-Components ---

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <img
            src={imageLogo}   // Replace with your logo image path
            alt="Build Start Logo"
            style={{ height: '35px', marginRight: '10px' }}  // Adjust size & spacing as needed
          />
          BUILD START</div>
        <nav className={`${styles.nav} ${isMenuOpen ? styles.navMobile : ''}`}>
          <ul className={styles.navLinks}>
            <li className={styles.closeIcon} onClick={toggleMenu}><FaTimes /></li>
            <li className={styles.activeLink} ><a href="/">Home Owner</a></li>
            <li><a href="/business-landing">For Building Professionals</a></li>
            <li><a href="/for-developers">For Renovators / Developers</a></li>
            <li><a href="/resources-hub">Resource Hub</a></li>
            <li><a href="/contact-support">Support</a></li>
            <li className={styles.mobileAuth}>
              <Link to="/login" className={styles.btnLogin}>Login</Link>
            </li>
            <li className={styles.mobileAuth}>
              <Link to="/select-role" className={styles.btnRegister}>Register</Link>
            </li>
          </ul>
        </nav>
        <div className={styles.headerRight}>
          <Link to="/login" className={styles.btnLogin}>Login</Link>
          <Link to="/select-role" className={styles.btnRegister}>Register</Link>
        </div>
        <div className={styles.menuIcon} onClick={toggleMenu}>
          <FaBars />
        </div>
      </div>
    </header>
  );
};

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className={styles.hero}>
      {/* Content Container */}
      <div className={styles.heroContent}>
        
        {/* 1. Rating Badge */}
        <div className={styles.ratingBadge}>
          <span className={styles.stars}>★★★★★</span>
          <span className={styles.ratingText}>310+ Reviews</span>
        </div>

        {/* 2. Title with Light/Bold mixture */}
        <h1 className={styles.heroTitle}>
          Assemble Your A-Team <br />
          <span className={styles.heroTitleLight}>of Consultants, Trades & Suppliers</span>
          in Minutes
        </h1>

        {/* 3. Subtitle */}
        <p className={styles.heroSubtitle}>
          Connect with highly professional local tradies in seconds.
        </p>

        {/* 4. Search Bar - Wrapped to maintain layout */}
        <div className={styles.heroSearchWrapper}>
          <SearchFormComponent className={styles.landingPageSearchForm} />
        </div>

      </div>
    </section>
  );
};



const TrustedBy = () => {
  return (
    <section className={styles.trustedBy}>
      <FeaturedBusinessBanner />
    </section>
  );
};

const LeadExamplesSection = () => {
  const [jobsData, setJobsData] = useState([]);

  const handleGetJobs = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/Jobs/GetLatestJobs`);
      setJobsData(response.data.slice(0, 10)); // Keep only 10 jobs
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to fetch jobs');
    }
  };

  useEffect(() => {
    handleGetJobs(); // Initial fetch

    const fetchInterval = setInterval(() => {
      handleGetJobs();
    }, 3 * 60 * 1000); // Fetch every 3 minutes

    const shiftInterval = setInterval(() => {
      setJobsData(prevJobs => {
        if (prevJobs.length === 0) return [];
        const newJobs = [...prevJobs];
        const firstJob = newJobs.shift();
        newJobs.push(firstJob);
        return newJobs;
      });
    }, 60 * 1000); // Shift every 1 minute

    return () => {
      clearInterval(fetchInterval);
      clearInterval(shiftInterval);
    };
  }, []);

  const jobSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <section className={styles.leadExamples}>
      <div className={styles.container}>
        <h2 className={`${styles.textCenter} ${styles.largeTitle}`}>Live Job Feed</h2>
        {jobsData.length > 0 ? (
          <Slider {...jobSettings}>
            {jobsData.map((job) => (
              <div key={job.job_id} className={styles.jobCard}>
                <h3>{job.name}</h3>
                <p>{job.postcode}</p>
                <p>{job.description}</p>
                <p>Budget: {job.budget || job.budgetAmount}</p>
              </div>
            ))}
          </Slider>
        ) : (
          <p className={styles.textCenter}>Loading jobs...</p>
        )}
      </div>
    </section>
  );
};

const PreconstructionProcess = () => {
  return (
    <section className={styles.preconstruction}>
      <div className={`${styles.container} ${styles.textCenter}`}>
        <h2>Power Your Preconstruction Process</h2>
        <div className={styles.processTags}>
          <button>General Contractors</button>
          <button className={styles.active}>Subcontractors</button>
          <button>Building Product Manufacturers</button>
          <button>Architect</button>
          <button>Air Conditioning</button>
          <button>All electrical services</button>
          <button>New Metering</button>
          <button>Power Poles</button>
          <button>Arborist</button>
          <button>Electrician</button>
          <button>Pools & Architect</button>
        </div>
      </div>
    </section>
  );
};

const Features = () => {
  const navigate = useNavigate();
  return (
    <section className={styles.features}>
      <div className={styles.container}>
        <div className={styles.featureItem}>
          <div className={styles.featureText}>
            <h2>For Consultants, Trades & Suppliers</h2>
            <p>Get in Front of Serious Clients
List your business on BuildStart to connect with developers and renovators ready to hire.</p>
            <p>&nbsp;</p>
            <button className={styles.btnPrimary} onClick={() => navigate('/select-role')}>List your business today</button>
            <button className={styles.btnSecondary} onClick={() => navigate('/business-landing')}>Learn More</button>
          </div>
          <div className={styles.featureImage}>
            <img src={imageBizConnect} alt="Connect with clients" />
          </div>
        </div>
        <div className={`${styles.featureItem} ${styles.reverse}`}>
          <div className={styles.featureText}>
            <h2>For Property Developers, Builders & Renovators</h2>
            <p>Build with Confidence
Quickly assemble your trusted project team — from town planners to surveyors, engineers to certifiers and suppliers.</p>
            <p>&nbsp;</p>
            <button className={styles.btnPrimary} onClick={() => navigate('/select-role')}>Post a job</button>
          </div>
           <div className={styles.featureImage}>
            <img src={imageJobs} alt="Post a job" />
          </div>
        </div>
        <div className={styles.featureItem}>
          <div className={styles.featureText}>
            <h2>Download our Mobile App</h2>
            <p>Manage Your Projects On The Go{<br />}{<br />}</p>
            <p>
            <ul className={styles.iconList}>
              <li><FaCheckCircle className={styles.iconBullet}/>Chat securely with your A-Team</li>
              <li><FaCheckCircle className={styles.iconBullet}/>Compare proposals in one place</li>
              <li><FaCheckCircle className={styles.iconBullet}/>Hire and manage anywhere, anytime</li>
            </ul>
              

</p>
            <p>&nbsp;</p>
            <button className={styles.btnPrimary}>Download the BuildStart Mobile App</button>
          </div>
           <div className={styles.featureImage}>
            <img src={imageConnect} alt="Social network" />
          </div>
        </div>
      </div>
    </section>
  );
};

const Stats = () => {
  return (
    <section className={styles.gettingStarted}>
      <div className={`${styles.container} ${styles.textCenter}`}>
        <h2>Why Developers & Renovators Choose BuildStart</h2>
        <p>Build Start allows you to build relationships with and make connections with trusted professionals to help you get any job done.</p>
        <div className={styles.statsGrid}>
          <div className={styles.statItem}>
            <span className={styles.statNumber}>10K+</span>
            <span className={styles.statLabel}>Active Projects</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statNumber}>$3M+</span>
            <span className={styles.statLabel}>Job Spend</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statNumber}>400+</span>
            <span className={styles.statLabel}>Metropolitan Areas Covered</span>
          </div>
        </div>
      </div>
    </section>
  );
};

const Testimonials = () => {
  // Array to hold testimonial data for easy management
  const testimonialsData = [
    {
      id: 1,
      headline: "Saved Us Weeks of Delays",
      quote: "We were struggling to find a reliable structural engineer in Sydney on a tight deadline. BuildStart connected us with a fully vetted professional in under 48 hours. The quality of their network is second to none.",
      name: "Sarah W.",
      location: "Sydney, NSW",
      avatar: "https://i.pravatar.cc/50?u=sarah"
    },
    {
      id: 2,
      headline: "Finally, a Directory I Can Trust",
      quote: "After getting burnt on other platforms, I was hesitant. But BuildStart's vetting process is legit. I found an amazing builder for our Geelong renovation who was professional, insured, and did fantastic work. It's a game-changer.",
      name: "David L.",
      location: "Geelong, VIC",
      avatar: "https://i.pravatar.cc/50?u=david"
    },
    {
      id: 3,
      headline: "My Go-To for Assembling a Project Team",
      quote: "As a developer, my time is everything. BuildStart is my first stop for putting together a new project team. From surveyors to certifiers in Brisbane, I can find everyone I need in one place. It has streamlined our pre-construction phase completely.",
      name: "Michael B.",
      location: "Brisbane, QLD",
      avatar: "https://i.pravatar.cc/50?u=michael"
    }
  ];

  return (
    <section className={styles.gettingStarted}>
      <div className={`${styles.container} ${styles.textCenter}`}>
        <h2>Hear What Our Users Across Australia Think</h2>
        <p>Real experiences from developers, builders, and renovators who trust BuildStart.</p>
        <div className={styles.testimonialSlider}>
          {/* Note: The arrows are for show; a real slider would need a library like React Slick */}
          <span className={styles.arrow}>‹</span>

          {/* Map over the testimonials data to render each card dynamically */}
          {testimonialsData.map((testimonial) => (
            <div key={testimonial.id} className={styles.testimonialCard}>
              <div className={styles.stars}>★★★★★</div>
              <h3>{testimonial.headline}</h3>
              <p>"{testimonial.quote}"</p>
              <div className={styles.userProfile}>
                <img src={testimonial.avatar} alt={`${testimonial.name}`} />
                <div>
                  <strong>{testimonial.name}</strong>
                  <span>{testimonial.location}</span>
                </div>
              </div>
            </div>
          ))}

          <span className={styles.arrow}>›</span>
        </div>
      </div>
    </section>
  );
};

const BuildStartSealOfApproval = () => {
  return (
    <section className={styles.sealOfApproval}>
      <div className={`${styles.container} ${styles.textCenter}`}>
        <h2>The Build Start Seal of approval</h2>
        <p>Our 4-point Vetting Gauntlet ensures every professional meets the highest standards of skill, reputation, and integrity.</p>
        <div className={styles.sealProcess}>
          <div className={styles.sealStep}>
            <div className={styles.sealIconWrapper}>
              <span className={styles.sealNumber}>1</span>
              <BsShieldCheck size={40} />
            </div>
            <h3>License & Insurance Verification</h3>
            <p>We verify every license, certification, and insurance policy to ensure they are current and valid.</p>
          </div>
          <div className={styles.sealStep}>
            <div className={styles.sealIconWrapper}>
              <span className={styles.sealNumber}>2</span>
              <BsGraphUp size={40} />
            </div>
            <h3>Reputation & Review Analysis</h3>
            <p>Our team meticulously analyzes online reviews and requires a minimum 3-star average rating.</p>
          </div>
          <div className={styles.sealStep}>
            <div className={styles.sealIconWrapper}>
              <span className={styles.sealNumber}>3</span>
              <BsClipboardCheck size={40} />
            </div>
            <h3>Portfolio & Craftsmanship Check</h3>
            <p>We review past work for quality, attention to detail, and consistency, ensuring true mastery of their craft.</p>
          </div>
          <div className={styles.sealStep}>
            <div className={styles.sealIconWrapper}>
              <span className={styles.sealNumber}>4</span>
              <BsBinoculars size={40} />
            </div>
            <h3>Continuous Quality Monitoring</h3>
            <p>Our work isn’t done. We continuously monitor performance and reviews to ensure standards are always met.</p>
          </div>



        </div>


                 <div className={styles.testimonialHighlight}>
                    <p>"BuildStart helped us find the right planning consultant in days. It saved weeks of delays and thousands in redesign costs.”</p>
                    <span><strong>- A. Developer,</strong> Sydney</span>
                </div>


      </div>
    </section>
  );
};

const GettingStarted = () => {
  return (
    <section className={styles.gettingStarted}>
      <div className={`${styles.container} ${styles.textCenter}`}>
        <h2>Getting Started is Simple</h2>
        <p>Your dream project is just a few clicks away. We’ve streamlined the process so you can focus on the results, not the search.</p>
        <div className={styles.steps}>
          <div className={styles.step}>
            <FaSearch size={50} className={styles.stepIcon} />
            <h3>1. Tell Us About Your Project</h3>
            <p>Use our advanced search or post a job brief. The more detail you provide, the better we can match you.</p>
          </div>
          <div className={styles.step}>
            <FaAward size={50} className={styles.stepIcon} />
            <h3>2. Receive Curated Matches</h3>
            <p>Forget endless lists. We’ll connect you with a select few MasterGuild professionals perfectly suited for your job.</p>
          </div>
          <div className={styles.step}>
            <FaComments size={50} className={styles.stepIcon} />
            <h3>3. Connect & Hire with Confidence</h3>
            <p>Chat directly, review portfolios, and hire the right pro, all within our secure platform. It’s that easy.</p>
          </div>
        </div>
                         <a href="/select-role" className={`${styles.btnPrimary} ${styles.largeButton}`}>Start Building Your A-Team Today</a>

      </div>
    </section>
  );
};


const Cta = () => {
  const navigate = useNavigate();
  return (
    <section className={styles.cta}>
      <div className={`${styles.container} ${styles.textCenterWhite}`}>
        <h2>Ready to Build Smarter, Not Harder?</h2>

          <div className={styles.heroCards}>
            <div className={styles.heroCard} onClick={() => navigate('/for-developers')}>
              <FaUserTie size={24} className={styles.heroIcon} />
              <div>
                <strong>I’m a Property Developer / Builder/ Renovator</strong>
                <p>&nbsp;</p>
                              <button
                className={styles.btnPrimary}
                onClick={() => navigate("/select-role")}
              >
                Find My A-Team
              </button>

              </div>
            </div>
            <div className={styles.heroCard} onClick={() => navigate('/business-landing')}>
               <FaHardHat size={24} className={styles.heroIcon} />
              <div>
                <strong>I’m a Consultant / Trade / Supplier</strong>
                <p>&nbsp;</p>
                              <button
                className={styles.btnPrimary}
                onClick={() => navigate("/select-role")}
              >
                List My Business
              </button>

              </div>
            </div>
          </div>


{     /*   
  <div className={styles.searchBar}>
          <input type="text" placeholder="Search Eg, plumber, electrician, surveyor" />
          <button className={styles.btnSearch} onClick={() => navigate('/login')}>Search</button>
        </div>
*/}
      </div>
    </section>
  );
};

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerMain}>
          <div className={styles.footerAbout}>
            <div className={styles.logo}>Build Start</div>
            <p>Lorem ipsum dolor sit consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
            <div className={styles.socialIcons}>
              <a href="#facebook">f</a>
              <a href="#twitter">t</a>
              <a href="#linkedin">in</a>
              <a href="#instagram">o</a>
            </div>
          </div>
          <div className={styles.footerLinks}>
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#owners">For Home Owners</a></li>
              <li><a href="#professionals">For Professionals</a></li>
              <li><a href="#jobs">Jobs</a></li>
              <li><a href="#social">Social Media</a></li>
              <li><a href="#prices">Prices</a></li>
              <li><a href="#education">Education Resources</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className={styles.footerLinks}>
            <h4>Directory</h4>
            <ul>
              <li><a href="#ac">Airconditioning</a></li>
              <li><a href="#builders">Builders</a></li>
              <li><a href="#concreters">Concreters</a></li>
              <li><a href="#design">Design</a></li>
              <li><a href="#estimators">Estimators</a></li>
              <li><a href="#gardeners">Gardeners</a></li>
              <li><a href="#more">More......</a></li>
            </ul>
          </div>
          <div className={styles.footerLinks}>
            <h4>Resources</h4>
            <ul>
              <li><a href="#terminology">Terminology</a></li>
              <li><a href="#charts">Flow Charts</a></li>
              <li><a href="#tips">Design Tips</a></li>
              <li><a href="#how-tos">How tos</a></li>
              <li><a href="#support">Support</a></li>
              <li><a href="#process">Our Process</a></li>
              <li><a href="#library">Resource library</a></li>
            </ul>
          </div>
        </div>
      </div>
       <div className={styles.footerBottom}>
          <p>©Copyright 2025 https://buildstart.au | All Rights Reserved</p>
        </div>
    </footer>
  );
};




const ProblemSolutionSection = () => {

  const navigate = useNavigate();

  const problems = [
    "Wasting time asking “Does anyone know a good surveyor?” in forums and groups",
    "Projects delayed because the wrong consultant caused costly mistakes",
    "No easy way to verify licenses, insurance, or real reputation",
    "Stress and lost profit trying to pull together a reliable project team",
  ];

  const solutions = [
    "Vetted consultants, trades & suppliers with verified credentials",
    "Peer-trusted reviews & proven track records",
    "Fast matching to the exact expertise you need",
    "One platform to search, connect & hire with confidence",
  ];



  return (
    <section className={styles.problemSolution}>
      <div className={styles.container}>
        <div className={styles.problemSolutionHeader}>
          <h2>The Problem Developers, Builders & Renovators Face</h2>
          <p className={styles.subheadline}>
            Why traditional hunting through groups and forums slows projects and increases risk.
          </p>
        </div>

        <div className={styles.problemSolutionGrid}>
          {/* Problem Card */}
          {/* Renamed from .problemCol to .problemCard for clarity */}
          <div className={styles.problemCard}>
            <h3 className={styles.problemTitle}>The Problem</h3>
            <ul className={styles.problemList}>
              {problems.map((item, i) => (
                <li key={i} className={styles.problemItem}>
                  <span className={styles.problemDot} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Solution Card */}
          {/* The extra wrapping .solutionCol div is removed */}
          <div className={styles.solutionCard}>
            <h3 className={styles.solutionTitle}>The BuildStart Solution</h3>
            <ul className={styles.solutionList}>
              {solutions.map((item, i) => (
                <li key={i} className={styles.solutionItem}>
                  <FaCheckCircle className={styles.solutionIcon} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <div className={styles.solutionCtas}>
              <button
                className={styles.btnPrimary}
                onClick={() => navigate("/select-role")}
              >
                Build My A-Team
              </button>
              <button
                className={styles.btnSecondary}
                onClick={() => navigate("/business-landing")}
              >
                List My Business
              </button>
            </div>
          </div>
        </div>

        <div className={styles.solutionReassure}>
            {/* Using spans directly is fine, or you can map over an array */}
            <span className={styles.reassureBadge}>Verified</span>
            <span>•</span>
            <span className={styles.reassureBadge}>License & Insurance checks</span>
            <span>•</span>
            <span className={styles.reassureBadge}>Portfolio review</span>
            <span>•</span>
            <span className={styles.reassureBadge}>Ongoing performance monitoring</span>
        </div>
      </div>
    </section>
  );
};




// --- Main Component ---

const BuildStartLandingPage = () => {
  const navigate = useNavigate();


  return (
    <>
     <SocialProofEngine />
      <Header />
      <main>
        <Hero />
        <TrustedBy />
        <ProblemSolutionSection />
        <BuildStartSealOfApproval />
        <LeadExamplesSection />

        {/*<PreconstructionProcess /> */}
        <Features />
        <GettingStarted />
        <Stats />
        <Testimonials />
        <Cta />
      </main>
      <Footer />

      <AiSearchAssistant />


    </>
  );
};

export default BuildStartLandingPage;
